import { LogLevel } from "@azure/msal-browser";


export const b2cPolicies = {
    names: {
        signUpSignIn: process.env.REACT_APP_SIGNINFLOW,
        forgotPassword: process.env.REACT_APP_FORGOT_PWD,
        editProfile: process.env.REACT_APP_EDIT_PROFILE,
    },
    authorities: {
        signUpSignIn: {
            authority: process.env.REACT_APP_B2C_AUTHRORITY + process.env.REACT_APP_SIGNINFLOW,
        },
        forgotPassword: {
            authority: process.env.REACT_APP_B2C_AUTHRORITY + process.env.REACT_APP_FORGOT_PWD,
        },
        editProfile: {
            authority: process.env.REACT_APP_B2C_AUTHRORITY + process.env.REACT_APP_EDIT_PROFILE,
        },
    },
    authorityDomain: process.env.REACT_APP_B2C_DOMAIN,
};

// authentication client for AAD
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENTID,
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
        redirectUri: '/',
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'sessionStorage', // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Trace,
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};


export const loginRequest = {
    scopes: [process.env.REACT_APP_API_SCOPE],
};


